import { typeInfo } from "../../../../../constants/typeInfo";
import { fillColorAtSubstance } from "../../../../../utils/textUtils";

import AntSynSymbol from "./AntSynSymbol";
import "./VocaCardBack.css";

const TEXT_COLOR = "#2D2D2D";

const VocaCardBack = ({ currentPage }) => {
  return (
    <div className="voca-card-back">
      <div className="voca-card-back__row">
        <div className="voca-card-back__word-cell">
          <div
            className="voca-card-back__word"
            style={{ color: typeInfo["vocabulary"].color }}
          >
            {currentPage.word}
          </div>
          <div className="voca-card-back__pron" style={{ color: TEXT_COLOR }}>
            {currentPage.pron}
          </div>
          {currentPage.syn && (
            <div className="voca-card-back__relation" style={{ color: TEXT_COLOR }}>
              <AntSynSymbol type="syn" />
              <div>
                {currentPage.syn.split("\n").map((line, index) => (
                  <div key={index}>{line}</div>
                ))}
              </div>
            </div>
          )}
          {currentPage.ant && (
            <div className="voca-card-back__relation" style={{ color: TEXT_COLOR }}>
              <AntSynSymbol type="ant" />
              <div>
                {currentPage.ant.split("\n").map((line, index) => (
                  <div key={index}>{line}</div>
                ))}
              </div>
            </div>
          )}
        </div>
        <div className="voca-card-back__meaning-cell" style={{ color: TEXT_COLOR }}>
          {currentPage.kor.split("\n").map((line, index) => (
            <div key={index}>
              {fillColorAtSubstance(line, typeInfo["vocabulary"].color)}
            </div>
          ))}
          {currentPage.eng.split("\n").map((line, index) => (
            <div key={index}>
              {fillColorAtSubstance(line, typeInfo["vocabulary"].color)}
            </div>
          ))}
        </div>
      </div>
      {currentPage.example && (
        <div className="voca-card-back__example">
          {currentPage.example_list.map((line, exampleIndex) => (
            <div key={exampleIndex}>
              <div>
                {line
                  .split(/(\{.*?\})/g)
                  .map((part, index) =>
                    part.startsWith("{") && part.endsWith("}") ? (
                      <strong key={index}>{part.slice(1, -1)}</strong>
                    ) : (
                      part
                    )
                  )}
              </div>
              <div>{currentPage.example_translation_list[exampleIndex]}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default VocaCardBack;
